import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Props } from './Burger';
import { toggleBurgerMenuRequested } from '../../redux/actions';
import { getIsBurgerMenuOpen } from '../../redux/selectors';

export type StateProps = Pick<Props, 'isBurgerMenuOpen'>;
export type DispatchProps = Pick<Props, 'toggleBurgerMenu'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = state => ({
  isBurgerMenuOpen: getIsBurgerMenuOpen(state),
});
const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  toggleBurgerMenu: toggleBurgerMenuRequested,
};

export default connect(mapStateToProps, mapDispatchToProps);
